import React from 'react';
import { func, object, oneOf, node, string } from 'prop-types';
import { H2 } from '@sohonet/ui-components/Typography';
import { Formik } from 'formik';
import styled from 'styled-components/macro';

import Dashboard, {
  DashboardHeader,
  DashboardBody
} from 'components/Dashboard';

import { CSS_OVERFLOW } from 'utils/constants';

const FormHeader = styled(H2)`
  margin: 0;
`;

const FormBody = styled(DashboardBody)`
  flex-grow: 1;
  overflow: ${({ overflowBehaviour }) => overflowBehaviour || ''};

  & > div {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-grow: 1;
    padding: 0;
  }
`;

const FormWrapper = ({
  children,
  formName,
  handleSubmit,
  initialValues,
  overflowBehaviour,
  validationSchema
}) => (
  <Dashboard>
    <DashboardHeader>
      <FormHeader data-testid="formHeader">{formName}</FormHeader>
    </DashboardHeader>
    <FormBody overflowBehaviour={overflowBehaviour}>
      <Formik
        validateOnChange={false}
        initialValues={initialValues}
        onSubmit={(values, actions) => handleSubmit(values, actions)}
        validationSchema={validationSchema}
      >
        {(props) => React.cloneElement(children, { ...props })}
      </Formik>
    </FormBody>
  </Dashboard>
);

/* TODO: investigate portals as alternative to passing `overflowBehaviour` prop */
FormWrapper.propTypes = {
  children: node.isRequired,
  formName: string.isRequired,
  handleSubmit: func.isRequired,
  initialValues: object,
  overflowBehaviour: oneOf([
    CSS_OVERFLOW.VISIBLE,
    CSS_OVERFLOW.HIDDEN,
    CSS_OVERFLOW.SCROLL,
    CSS_OVERFLOW.AUTO
  ]),
  validationSchema: object
};

FormWrapper.defaultProps = {
  initialValues: {},
  validationSchema: {}
};

export default FormWrapper;
